// src/components/layout/Sidebar.tsx

import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import {
  AppstoreOutlined,
  UserOutlined,
  HomeOutlined,
  ProductOutlined,
  OneToOneOutlined, // ✅ 新增：OTA 图标
} from '@ant-design/icons';

/**
 * 侧边栏菜单组件
 */
export const Sidebar = () => {
  const location = useLocation();

  // 菜单项定义
  const items: MenuProps['items'] = [
    {
      key: '/dashboard',
      icon: <HomeOutlined className="text-gray-500" />,
      label: <Link to="/">概况</Link>,
    },
    {
      key: '/apps',
      icon: <AppstoreOutlined />,
      label: <Link to="/apps">App SDK</Link>,
    },
    {
      key: '/products',
      icon: <ProductOutlined />,
      label: <Link to="/products">产品管理</Link>,
    },
    {
      key: '/panels',
      icon: <OneToOneOutlined />,
      label: <Link to="/panels">面板管理</Link>,
    },
    {
      key: 'developer',
      icon: <UserOutlined />,
      label: '开发者',
      children: [
        {
          key: '/profile',
          label: <Link to="/profile">个人信息</Link>,
        },
        {
          key: '/password',
          label: <Link to="/password">修改密码</Link>,
        },
      ],
    },
  ];

  // 根据当前路径设置选中项
  const getSelectedKey = (): string => {
    const path = location.pathname;
    if (path.startsWith('/product-images')) return '/products'; 
    if (path.startsWith('/products')) return '/products';
    if (path.startsWith('/apps')) return '/apps';
    if (path.startsWith('/panels')) return '/panels';
    if (path.startsWith('/categories')) return '/categories';
    if (path === '/password') return '/password';
    if (path === '/profile') return '/profile';
    if (path.startsWith('/settings/delete-account')) return '/profile';
    return '/dashboard';
  };

  return (
    <aside className="w-64 bg-white border-r border-gray-100 shrink-0">
      {/* 侧边栏头部 - 新增平台名称，与Header呼应 */}
      {/* <div className="px-6 py-5 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-800">开发者管理中心</h2>
      </div> */}
      {/* 菜单 - 优化样式、选中态、间距、高度 */}
      <Menu
        mode="inline"
        selectedKeys={[getSelectedKey()]}
        items={items}
        className="h-full border-0 bg-white"
        // 核心修改：添加 as React.CSSProperties 类型断言
        style={{
          '--ant-menu-item-active-bg': '#f0f7ff',
          '--ant-menu-item-selected-bg': '#e6f0ff',
          '--ant-menu-item-selected-color': '#165DFF',
          '--ant-menu-hover-bg': '#f5faff',
          '--ant-menu-border-color': 'transparent',
          padding: '8px 0'
        } as React.CSSProperties} // 关键：类型断言，解决TS报错
      />
    </aside>

  );
};